import { WithLogger } from '../../logger/WithLogger';
export class BaseClient extends WithLogger {
  constructor(client, logger) {
    super(logger);
    this.client = client;
  }
}
//# sourceMappingURL=BaseClient.js.map